//@ts-nocheck
import { Box, ButtonNew, Spacer, Text, TextInputNew } from '@jfs/ui-new'
import { useState } from 'react'
import { TooltipView } from '../../Insights/TooltipView'
import { CheckboxList } from './CheckboxList'

const AddWebHookView = () => {
  const [checkboxData, setCheckboxData] = useState([
    { text: 'Intent', isChecked: true },
    { text: 'Purchase', isChecked: true },
    { text: 'Refund', isChecked: true },
  ])
  return (
    <>
      <Box>
        <Box flexDirection="row">
          <Text fontSize={14} fontWeight="BOLD">
            Webhook URL
          </Text>
          <TooltipView value="Webhook url can only be delivered to Public url" />
        </Box>
        <Spacer size={15} />
        <TextInputNew padding={8} borderRadius={4} type="body12" borderColor="GRAY_BORDER" />
      </Box>
      <Box>
        <Box flexDirection="row" paddingVertical={20}>
          <Text fontSize={14} fontWeight="BOLD">
            Alert Email
          </Text>
          <TooltipView value="Webhook url can only be delivered to Public url" />
        </Box>
        <Spacer size={15} />
        <TextInputNew padding={8} borderRadius={4} type="body12" borderColor="GRAY_BORDER" />
      </Box>

      <Box>
        <Box flexDirection="row" justifyContent="space-between" marginTop={20}>
          <Text> Active Event(1)</Text>

          <ButtonNew type="tertiary" title="Clear All" onPress={() => {}} />
        </Box>

        <Box>
          <CheckboxList checkboxData={checkboxData} setCheckboxData={setCheckboxData} flexDirection="column" />
        </Box>
      </Box>
    </>
  )
}

export { AddWebHookView }
